module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ1_5.78a9cc13.svg";